import { BuildingClass, CharacterClass, GameGenerators, HubClass, UnitType } from '../../types/game-types';

export const generators: GameGenerators = {
  // TROOPS
  // Level 1
  warrior: {
    level: 1,
    id: CharacterClass.Warrior,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 3.5,
    },
    costGrowthRate: 1.25,
    baseGeneration: 0.75,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  wizard: {
    level: 1,
    id: CharacterClass.Wizard,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 5,
    },
    costGrowthRate: 1.25,
    baseGeneration: 1.5,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  elf: {
    level: 1,
    id: CharacterClass.Elf,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 6.5,
    },
    costGrowthRate: 1.3,
    baseGeneration: 1,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },

  // Level 2
  garrison: {
    level: 2,
    id: BuildingClass.Garrison,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 250,
      // food: 90,
    },
    costGrowthRate: 1.45,
    baseGeneration: 1,
    ticksToGenerate: 20,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  academy: {
    level: 2,
    id: BuildingClass.Academy,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 350,
    },
    costGrowthRate: 1.4,
    baseGeneration: 1,
    ticksToGenerate: 20,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  outpost: {
    level: 2,
    id: BuildingClass.Outpost,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 550,
    },
    costGrowthRate: 1.4,
    baseGeneration: 1,
    ticksToGenerate: 25,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  // Level 3
  council: {
    level: 3,
    id: HubClass.MilitaryCouncil,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 3000,
      // wood: 500,
      // ore: 5,
    },
    costGrowthRate: 1.65,
    baseGeneration: 1,
    ticksToGenerate: 45,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  nexus: {
    level: 3,
    id: HubClass.WizardNexus,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 5000,
    },
    costGrowthRate: 1.6,
    baseGeneration: 1,
    ticksToGenerate: 45,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },
  forest: {
    level: 3,
    id: HubClass.Forest,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 7000,
    },
    costGrowthRate: 1.6,
    baseGeneration: 1,
    ticksToGenerate: 50,
    isUnlocked: false,
    type: UnitType.TROOPS,
  },

  // SUPPORT
  // Level 1
  thief: {
    level: 1,
    id: CharacterClass.Thief,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 9,
    },
    costGrowthRate: 1.4,
    baseGeneration: 1,
    ticksToGenerate: 5,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  bard: {
    level: 1,
    id: CharacterClass.Bard,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 12,
    },
    costGrowthRate: 1.7,
    baseGeneration: 0.01,
    // baseGeneration: 10,
    ticksToGenerate: 1,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  cleric: {
    level: 1,
    id: CharacterClass.Cleric,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 100,
    },
    costGrowthRate: 2.0,
    baseGeneration: 1,
    ticksToGenerate: 60,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },

  // Level 2
  guild: {
    level: 2,
    id: BuildingClass.Guild,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 500,
    },
    costGrowthRate: 1.6,
    baseGeneration: 1,
    ticksToGenerate: 30,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  troupe: {
    level: 2,
    id: BuildingClass.Troupe,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 1000,
    },
    costGrowthRate: 1.6,
    baseGeneration: 1,
    ticksToGenerate: 30,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  seminary: {
    level: 2,
    id: BuildingClass.Seminary,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 2000,
    },
    costGrowthRate: 2.1,
    baseGeneration: 1,
    ticksToGenerate: 150,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  congress: {
    level: 3,
    id: HubClass.ShadowCongress,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 6000,
    },
    costGrowthRate: 1.9,
    baseGeneration: 1,
    ticksToGenerate: 45,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  theater: {
    level: 3,
    id: HubClass.Theater,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 7000,
    },
    costGrowthRate: 1.9,
    baseGeneration: 1,
    ticksToGenerate: 45,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },
  college: {
    level: 3,
    id: HubClass.College,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 10000,
    },
    costGrowthRate: 2.5,
    baseGeneration: 1,
    ticksToGenerate: 300,
    isUnlocked: false,
    type: UnitType.SUPPORT,
  },

  // RESOURCES
  farmer: {
    level: 1,
    id: CharacterClass.Farmer,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 7,
    },
    costGrowthRate: 1.5,
    baseGeneration: 1,
    ticksToGenerate: 3,
    isUnlocked: false,
    type: UnitType.RESOURCES,
  },
  lumberjack: {
    level: 1,
    id: CharacterClass.Lumberjack,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 7,
    },
    costGrowthRate: 1.5,
    baseGeneration: 1,
    ticksToGenerate: 3,
    isUnlocked: false,
    type: UnitType.RESOURCES,
  },
  miner: {
    level: 1,
    id: CharacterClass.Miner,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 7,
    },
    costGrowthRate: 1.5,
    baseGeneration: 1,
    ticksToGenerate: 3,
    isUnlocked: false,
    type: UnitType.RESOURCES,
  },

  // ENGINEERING
  catapult: {
    level: 1,
    id: CharacterClass.Catapult,
    owned: 0,
    purchased: 0,
    cost: {
      gold: 10000,
    },
    costGrowthRate: 1.5,
    baseGeneration: 1000,
    ticksToGenerate: 3,
    isUnlocked: false,
    type: UnitType.ENGINEERING,
  },
};
